import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

// 引入所有组件modules
import main from './main'
import meeting from './meeting'
import asset from './asset'
import storage from './storage'


const modules = {
  main,
  meeting,
  asset,
  storage,
}
const store = new Vuex.Store({
  modules
})
export default store


// WEBPACK FOOTER //
// ./src/store/index.js